import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <Routes>
        {/* Home — funciona no subdomínio e na subpasta graças ao basename dinâmico */}
        <Route path="/" element={<Index />} />

        {/* Espelhos opcionais */}
        <Route path="/sucesso" element={<Index />} />
        <Route path="/gopass-e-confiavel" element={<Index />} />
        <Route path="/gopass-reclame-aqui" element={<Index />} />

        {/* Rota de diagnóstico rápida */}
        <Route path="/health" element={<h1 style={{padding:24}}>OK</h1>} />

        {/* Fallback */}
        <Route path="*" element={<Index />} />
      </Routes>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
